import { createFileRoute } from '@tanstack/react-router';
import { evaluateModeratorAccess, requireAdminAccess } from '../../../features/admin';
import { StatisticsPage } from '../../../features/statistics';

export const Route = createFileRoute('/_auth/admin/statistics')({
  beforeLoad: requireAdminAccess(evaluateModeratorAccess),
  component: StatisticsPage,
});
